<mg-action-box>
    <mg-visual-great-success></mg-visual-great-success>
    <div class="message">
        <mg-visual-logo class="submitLogo"></mg-visual-logo>
        <h2 i18n="@@configurator.celebrate.title">Your offer request succeeded, we've send you an e-mail</h2>
        <p i18n="@@configurator.celebrate.description">We'll contact you as soon as possible</p>
        <mg-ui-button [linkTarget]="homeUrl" i18n="@@configurator.celebrate.back-link"
            >Back to the homepage</mg-ui-button
        >
    </div>
</mg-action-box>
